/* global angular  moment swal _*/
import './style.less';
import { specialTopics } from '@prolaera/library';

export default function($log, $state, $stateParams, $q, Swal, ApiClass, ProfileClass, ResolveClass) {
  'ngInject';

  const vm = this;

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  const { profile } = ProfileClass.profileComplete;
  vm.disable = profile && profile.company_id === 10 && !profile.admin;

  vm.btnAction = false;
  // THIS IS NEEDED FOR INFINITE SCROLL
  vm.dataCollection = [];
  vm.dateOptions = {
    minDate: new Date(1980, 1, 1),
    maxDate: new Date()
  };
  vm.specialTopicsDict = _.keyBy(specialTopics, 'key');
  vm.specialTopics = specialTopics.map(({ key }) => key);
  vm.dateFilters = {
    start: {
      opened: false
    },
    end: {
      opened: false
    }
  };

  vm.filterDate = () => {
    vm.rawCollection = angular.copy(vm.Certificates);

    if (vm.dateFilters.start.value) {
      const startFilterDate = new Date(vm.dateFilters.start.value);
      vm.rawCollection = vm.rawCollection.filter(item => new Date(item.date) >= startFilterDate);
    }

    if (vm.dateFilters.end.value) {
      const endFilterDate = new Date(vm.dateFilters.end.value);
      vm.rawCollection = vm.rawCollection.filter(item => new Date(item.date) <= endFilterDate);
    }
  };

  vm.wrapContent = false;
  vm.employeeCss = $state.current.name === 'app.admin.employees.employee.certificates';
  vm.profileUid = $stateParams.employeeID || $stateParams.id;
  // TODO: MOVE to templating -CH

  if ($state.current.name === 'app.users.certificates') vm.wrapContent = true;

  vm.who = "you don't ";
  vm.filterVisable = false;
  vm.toggleFilter = () => (vm.filterVisable = !vm.filterVisable);
  vm.toggleRow = cert => (cert.displayInfo = !cert.displayInfo);

  vm.delete = cert => {
    const certId = cert.cert_id;
    Swal.delete()
      .then(() => {
        vm.btnAction = true;

        ApiClass.usersIdTypeTypeIdDelete(
          { id: profile_uid, type: 'certificates', type_id: certId, manage: false },
          {},
          {}
        )
          .then(() => {
            Swal.toast('Course deleted');
            vm.btnAction = false;
            $state.reload();
          })
          .catch(error => {
            vm.btnAction = false;
            $log.error(error);
            throw error;
          });
      })
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  function createUniques(certsArr) {
    vm.CreditsGroup = certsArr.reduce((arr, { credits_arr }) => _.uniq(arr.concat(credits_arr)), []);
  }

  const qArr = [
    ApiClass.companiesIdGet(
      { id: profile.company_id, manage: false },
      {},
      {
        queryParams: {
          categories: true,
          vendors: true,
          regulators: true
        }
      }
    ),
    ApiClass.usersIdGet(
      { id: profile_uid, manage: false },
      {},
      {
        queryParams: {
          'include:flatcompliance': true,
          'filter:flatcompliance:latest': true,
          'include:certificates': true
        }
      }
    )
  ];

  $q.all(qArr)
    .then(([{ data: { categories, regulators, vendors } }, { data: { certificates, flatcompliance } }]) => {
      $log.debug('User Certificates Arguments', arguments);

      vm.Certificates = certificates;
      vm.Categories = categories;
      vm.Vendors = _.keyBy(vendors, 'vendor_id');
      vm.flatCompCur = flatcompliance;
      vm.flatCompCurArr = Object.keys(flatcompliance).map(key => flatcompliance[key]);

      const regulatorDict = regulators.reduce((obj, item) => {
        if (!obj[item.reg_id]) obj[item.reg_id] = {};
        obj[item.reg_id][item.date] = item;
        return obj;
      }, {});

      vm.Certificates.forEach((cert, certIndex) => {
        vm.Certificates[certIndex].category_id_arr = [];
        vm.Certificates[certIndex].credits_arr = [];

        if (cert.hours) {
          cert.hours.forEach(hour => {
            vm.Certificates[certIndex].category_id_arr.push(hour.category_id);
            vm.Certificates[certIndex].credits_arr.push(hour.credits);
          });
        } else {
          vm.Certificates[certIndex].category_id_arr.push(cert.category_id);
          vm.Certificates[certIndex].credits_arr.push(cert.credits);
        }

        cert.date = new Date(cert.date) !== 'Invalid Date' ? cert.date : cert.sortDate || Date.now();
        vm.Certificates[certIndex].sortDate = moment(
          new Date(cert.date || cert.sortDate || Date.now()).toISOString(),
          'YYYY-MM-DD HH:mm'
        );
        vm.Certificates[certIndex]['licenseApp'] = [];
        vm.flatCompCurArr.forEach((license, licenseIndex) => {
          const regulator = regulatorDict[license.reg_id][license.reg_date];

          let updated = false;

          if (regulator && cert.category_id && regulator.tech && regulator.tech.indexOf(cert.category_id) > -1) {
            vm.Certificates[certIndex]['licenseApp'].push(license.reg_id);
          }

          if (cert.hours) {
            for (let i = 0; i < cert.hours.length; i++) {
              if (
                !updated &&
                regulator &&
                cert.hours[i].category_id &&
                regulator.tech &&
                regulator.tech.indexOf(cert.hours[i].category_id) > -1
              ) {
                updated = true;
                vm.Certificates[certIndex]['licenseApp'].push(license.reg_id);
              }
            }
          }

          cert.pdf += `?time=${new Date().getTime()}`;
        });
      });
      createUniques(vm.Certificates);
      const rawCollection = angular.copy(vm.Certificates);
      vm.rawCollection = _.orderBy(rawCollection, ['sortDate'], ['desc']);
      vm.resultsQueried = true;
    })
    .catch(error => {
      $log.error(error);
      throw error;
    });
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/certificates/get/index.js